import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as appsActions from "../../actions/appsActions";

const createAppSuccessLogic = createLogic({
	type: ActionTypes.CREATE_APP_SUCCESS,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(appsActions.loadApps());
		done();
	},
});

export default [createAppSuccessLogic];
